function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1185px",
    height: "1074px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f94be",
    d: "M 944.5,236.5 C 922.5,237.167 900.5,237.833 878.5,238.5C 867.992,239.447 858.325,242.78 849.5,248.5C 741.72,156.642 618.72,127.475 480.5,161C 362.995,196.182 277.828,269.015 225,379.5C 188.725,461.8 180.725,546.8 201,634.5C 230.17,746.293 294.67,830.793 394.5,888C 490.89,939.192 591.556,950.192 696.5,921C 754.406,903.23 805.739,874.397 850.5,834.5C 854.1,832.57 857.1,829.903 859.5,826.5C 950.761,733.903 989.927,622.57 977,492.5C 971.677,450.537 959.844,410.537 941.5,372.5C 942.246,371.264 942.579,369.93 942.5,368.5C 969.841,368.167 997.175,368.5 1024.5,369.5C 1069.13,487.14 1068.3,604.473 1022,721.5C 964.854,853.314 868.521,942.981 733,990.5C 593.363,1033.4 460.863,1017.57 335.5,943C 206.592,859.125 133.092,740.292 115,586.5C 104.082,432.866 153.582,302.7 263.5,196C 372.805,98.0156 500.805,57.3489 647.5,74C 767.308,91.2169 866.308,145.384 944.5,236.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8dc9de",
    d: "M 944.5,236.5 C 945.043,236.56 945.376,236.893 945.5,237.5C 923.177,238.5 900.843,238.833 878.5,238.5C 900.5,237.833 922.5,237.167 944.5,236.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#80c33d",
    d: "M 881.5,265.5 C 906.167,265.5 930.833,265.5 955.5,265.5C 920.668,299.831 885.335,333.664 849.5,367C 844.534,371.455 840.2,376.289 836.5,381.5C 839.713,350.75 843.546,320.083 848,289.5C 854.3,274.7 865.466,266.7 881.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7ac23d",
    d: "M 955.5,265.5 C 981.169,265.333 1006.84,265.5 1032.5,266C 1006,290.67 979.997,315.837 954.5,341.5C 942.5,341.5 930.5,341.5 918.5,341.5C 917.457,353.217 916.124,364.883 914.5,376.5C 913.961,379.042 912.628,381.208 910.5,383C 882.608,409.394 854.942,435.894 827.5,462.5C 830.135,435.453 833.135,408.453 836.5,381.5C 840.2,376.289 844.534,371.455 849.5,367C 885.335,333.664 920.668,299.831 955.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#77c244",
    d: "M 881.5,265.5 C 934.332,264.335 987.332,264.168 1040.5,265C 1066.2,269.891 1077.7,285.391 1075,311.5C 1071.28,326.891 1061.78,336.724 1046.5,341C 1015.84,341.5 985.168,341.667 954.5,341.5C 979.997,315.837 1006,290.67 1032.5,266C 1006.84,265.5 981.169,265.333 955.5,265.5C 930.833,265.5 906.167,265.5 881.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#75c140",
    d: "M 914.5,376.5 C 911.257,408.023 907.591,439.357 903.5,470.5C 903.664,467.813 903.497,465.146 903,462.5C 881.803,483.365 860.303,503.865 838.5,524C 830.874,531.118 823.874,538.618 817.5,546.5C 820.671,518.466 824.004,490.466 827.5,462.5C 854.942,435.894 882.608,409.394 910.5,383C 912.628,381.208 913.961,379.042 914.5,376.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6cb34",
    d: "M 343.5,384.5 C 317.829,409.504 291.829,434.171 265.5,458.5C 262.075,434.024 259.075,409.357 256.5,384.5C 285.5,384.5 314.5,384.5 343.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9fc933",
    d: "M 343.5,384.5 C 369.167,384.5 394.833,384.5 420.5,384.5C 371.562,430.935 322.729,477.602 274,524.5C 273.617,523.944 273.117,523.611 272.5,523.5C 269.756,501.884 267.423,480.217 265.5,458.5C 291.829,434.171 317.829,409.504 343.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#99c835",
    d: "M 420.5,384.5 C 449.833,384.5 479.167,384.5 508.5,384.5C 482.167,409.833 455.833,435.167 429.5,460.5C 400.5,460.5 371.5,460.5 342.5,460.5C 342.232,462.099 342.566,463.432 343.5,464.5C 346.053,486.811 348.386,509.145 350.5,531.5C 350.643,533.262 350.309,534.929 349.5,536.5C 326.422,558.248 303.755,580.248 281.5,602.5C 278.281,576.194 275.281,549.86 272.5,523.5C 273.117,523.611 273.617,523.944 274,524.5C 322.729,477.602 371.562,430.935 420.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#92c736",
    d: "M 508.5,384.5 C 534.167,384.5 559.833,384.5 585.5,384.5C 559.167,409.833 532.833,435.167 506.5,460.5C 480.833,460.5 455.167,460.5 429.5,460.5C 455.833,435.167 482.167,409.833 508.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8cc537",
    d: "M 585.5,384.5 C 612.167,384.5 638.833,384.5 665.5,384.5C 639.804,410.196 613.804,435.53 587.5,460.5C 560.5,460.5 533.5,460.5 506.5,460.5C 532.833,435.167 559.167,409.833 585.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#86c439",
    d: "M 665.5,384.5 C 691.167,384.5 716.833,384.5 742.5,384.5C 716.196,409.47 690.196,434.804 664.5,460.5C 638.833,460.5 613.167,460.5 587.5,460.5C 613.804,435.53 639.804,410.196 665.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#80c33c",
    d: "M 742.5,384.5 C 748.5,384.5 754.5,384.5 760.5,384.5C 757.718,410.208 754.718,435.875 751.5,461.5C 698.201,511.132 645.534,561.465 593.5,612.5C 563.833,612.5 534.167,612.5 504.5,612.5C 530.833,587.167 557.167,561.833 583.5,536.5C 610.833,536.5 638.167,536.5 665.5,536.5C 668.259,511.429 671.259,486.429 674.5,461.5C 671.375,460.521 668.042,460.187 664.5,460.5C 690.196,434.804 716.196,409.47 742.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e3f0cc",
    d: "M 429.5,460.5 C 455.167,460.5 480.833,460.5 506.5,460.5C 533.5,460.5 560.5,460.5 587.5,460.5C 613.167,460.5 638.833,460.5 664.5,460.5C 668.042,460.187 671.375,460.521 674.5,461.5C 564.167,461.5 453.833,461.5 343.5,461.5C 343.5,462.5 343.5,463.5 343.5,464.5C 342.566,463.432 342.232,462.099 342.5,460.5C 371.5,460.5 400.5,460.5 429.5,460.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7bc23d",
    d: "M 751.5,461.5 C 749.531,481.892 747.197,502.225 744.5,522.5C 712.837,552.163 681.504,582.163 650.5,612.5C 631.5,612.5 612.5,612.5 593.5,612.5C 645.534,561.465 698.201,511.132 751.5,461.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6fbf41",
    d: "M 903.5,470.5 C 901.139,496.713 898.139,522.713 894.5,548.5C 865.833,575.5 837.167,602.5 808.5,629.5C 811.134,601.792 814.134,574.125 817.5,546.5C 823.874,538.618 830.874,531.118 838.5,524C 860.303,503.865 881.803,483.365 903,462.5C 903.497,465.146 903.664,467.813 903.5,470.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8cc63a",
    d: "M 506.5,536.5 C 488.668,554.498 470.335,571.998 451.5,589C 445.569,594.424 440.236,600.258 435.5,606.5C 432.195,583.379 429.528,560.045 427.5,536.5C 453.833,536.5 480.167,536.5 506.5,536.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#86c439",
    d: "M 506.5,536.5 C 532.167,536.5 557.833,536.5 583.5,536.5C 557.167,561.833 530.833,587.167 504.5,612.5C 481.27,613.14 458.27,612.474 435.5,610.5C 435.5,609.167 435.5,607.833 435.5,606.5C 440.236,600.258 445.569,594.424 451.5,589C 470.335,571.998 488.668,554.498 506.5,536.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#77c140",
    d: "M 744.5,522.5 C 741.386,552.527 738.053,582.527 734.5,612.5C 706.5,612.5 678.5,612.5 650.5,612.5C 681.504,582.163 712.837,552.163 744.5,522.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#93c738",
    d: "M 350.5,531.5 C 353.81,554.621 356.477,577.954 358.5,601.5C 338.671,620.495 318.671,639.328 298.5,658C 294.893,661.098 291.893,664.598 289.5,668.5C 286.482,646.682 283.815,624.682 281.5,602.5C 303.755,580.248 326.422,558.248 349.5,536.5C 350.309,534.929 350.643,533.262 350.5,531.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#67be42",
    d: "M 894.5,548.5 C 891.636,580.731 887.97,612.731 883.5,644.5C 883.565,644.062 883.399,643.728 883,643.5C 840.635,683.7 798.468,724.033 756.5,764.5C 726.833,764.5 697.167,764.5 667.5,764.5C 693.833,739.167 720.167,713.833 746.5,688.5C 764.833,688.5 783.167,688.5 801.5,688.5C 803.336,668.635 805.669,648.968 808.5,629.5C 837.167,602.5 865.833,575.5 894.5,548.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8dc63a",
    d: "M 358.5,601.5 C 361.737,624.294 364.404,647.294 366.5,670.5C 344.672,691.495 322.672,712.328 300.5,733C 298.393,734.264 297.393,736.097 297.5,738.5C 294.19,715.379 291.523,692.046 289.5,668.5C 291.893,664.598 294.893,661.098 298.5,658C 318.671,639.328 338.671,620.495 358.5,601.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#deefcd",
    d: "M 435.5,610.5 C 458.27,612.474 481.27,613.14 504.5,612.5C 534.167,612.5 563.833,612.5 593.5,612.5C 612.5,612.5 631.5,612.5 650.5,612.5C 678.5,612.5 706.5,612.5 734.5,612.5C 635.001,613.499 535.335,613.833 435.5,613.5C 435.5,612.5 435.5,611.5 435.5,610.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#62bd44",
    d: "M 883.5,644.5 C 879.606,683.883 875.272,723.217 870.5,762.5C 832.721,764.484 794.721,765.151 756.5,764.5C 798.468,724.033 840.635,683.7 883,643.5C 883.399,643.728 883.565,644.062 883.5,644.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#86c43a",
    d: "M 366.5,670.5 C 367.818,676.383 368.485,682.383 368.5,688.5C 386.833,688.5 405.167,688.5 423.5,688.5C 397.804,714.196 371.804,739.53 345.5,764.5C 330.5,764.5 315.5,764.5 300.5,764.5C 300.795,762.265 300.461,760.265 299.5,758.5C 298.323,751.903 297.656,745.237 297.5,738.5C 297.393,736.097 298.393,734.264 300.5,733C 322.672,712.328 344.672,691.495 366.5,670.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7fc33b",
    d: "M 423.5,688.5 C 453.167,688.5 482.833,688.5 512.5,688.5C 486.167,713.833 459.833,739.167 433.5,764.5C 404.167,764.5 374.833,764.5 345.5,764.5C 371.804,739.53 397.804,714.196 423.5,688.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#79c13c",
    d: "M 512.5,688.5 C 538.167,688.5 563.833,688.5 589.5,688.5C 563.167,713.833 536.833,739.167 510.5,764.5C 484.833,764.5 459.167,764.5 433.5,764.5C 459.833,739.167 486.167,713.833 512.5,688.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#73c03e",
    d: "M 589.5,688.5 C 614.833,688.5 640.167,688.5 665.5,688.5C 639.804,714.196 613.804,739.53 587.5,764.5C 561.833,764.5 536.167,764.5 510.5,764.5C 536.833,739.167 563.167,713.833 589.5,688.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6dbf3f",
    d: "M 665.5,688.5 C 692.5,688.5 719.5,688.5 746.5,688.5C 720.167,713.833 693.833,739.167 667.5,764.5C 640.833,764.5 614.167,764.5 587.5,764.5C 613.804,739.53 639.804,714.196 665.5,688.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dbeece",
    d: "M 299.5,758.5 C 300.461,760.265 300.795,762.265 300.5,764.5C 315.5,764.5 330.5,764.5 345.5,764.5C 374.833,764.5 404.167,764.5 433.5,764.5C 459.167,764.5 484.833,764.5 510.5,764.5C 536.167,764.5 561.833,764.5 587.5,764.5C 614.167,764.5 640.833,764.5 667.5,764.5C 697.167,764.5 726.833,764.5 756.5,764.5C 794.721,765.151 832.721,764.484 870.5,762.5C 870.5,763.5 870.5,764.5 870.5,765.5C 680.167,765.5 489.833,765.5 299.5,765.5C 299.5,763.167 299.5,760.833 299.5,758.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#66be46",
    d: "M 718.5,803.5 C 718.427,805.027 719.094,806.027 720.5,806.5C 721.5,806.833 722.167,807.5 722.5,808.5C 722.427,810.027 723.094,811.027 724.5,811.5C 735.535,831.795 732.535,849.962 715.5,866C 698.551,877.479 681.885,877.312 665.5,865.5C 665.027,864.094 664.027,863.427 662.5,863.5C 648.954,849.732 645.787,833.732 653,815.5C 665.808,794.34 683.975,787.84 707.5,796C 711.542,798.016 715.209,800.516 718.5,803.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6e0a5",
    d: "M 718.5,803.5 C 719.906,803.973 720.573,804.973 720.5,806.5C 719.094,806.027 718.427,805.027 718.5,803.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#75c142",
    d: "M 456.5,866.5 C 456.027,865.094 455.027,864.427 453.5,864.5C 441.393,853.91 436.893,840.576 440,824.5C 447.287,801.226 463.121,790.726 487.5,793C 512.329,800.185 523.163,816.685 520,842.5C 511.999,867.091 495.165,877.257 469.5,873C 464.547,871.857 460.214,869.69 456.5,866.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5dfa4",
    d: "M 722.5,808.5 C 723.906,808.973 724.573,809.973 724.5,811.5C 723.094,811.027 722.427,810.027 722.5,808.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#80bdd8",
    d: "M 859.5,826.5 C 857.1,829.903 854.1,832.57 850.5,834.5C 852.9,831.097 855.9,828.43 859.5,826.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5dfa2",
    d: "M 662.5,863.5 C 664.027,863.427 665.027,864.094 665.5,865.5C 663.973,865.573 662.973,864.906 662.5,863.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bbe0a1",
    d: "M 453.5,864.5 C 455.027,864.427 456.027,865.094 456.5,866.5C 454.973,866.573 453.973,865.906 453.5,864.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a3060931fc72390154beeed14b43e174.svg";
export { ForwardRef as ReactComponent };